export default "__VITE_ASSET__BZkB_qHw__"